import { ReactComponent as CheckIconSvg } from "../../icons/check.svg";

export default function CheckIcon({...props}){
  return(
    <CheckIconSvg width={"16px"} height={"16px"} fill="white" {...props}/>
  )
}

